import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroWBSequentialDVGroup,
  selectMeteorologyAgroWBSequentialDVLocation,
  selectMeteorologyAgroWBSequentialDVPeriodEnd,
  selectMeteorologyAgroWBSequentialDVPeriodStart,
  selectMeteorologyAgroWBSequentialDVSoil,
} from 'redux/reducers/meteorologyAgroWBSequentialDVReducer';
import { GetSequentialGraphParams } from 'types/Meteorology/Agro/WaterBalanceSequential/DetailedView/getGraph';

export default function useParams() {
  const groupId = useSelector(selectMeteorologyAgroWBSequentialDVGroup);
  const locationId = useSelector(selectMeteorologyAgroWBSequentialDVLocation);
  const soilId = useSelector(selectMeteorologyAgroWBSequentialDVSoil);
  const startDate = useSelector(selectMeteorologyAgroWBSequentialDVPeriodStart);
  const endDate = useSelector(selectMeteorologyAgroWBSequentialDVPeriodEnd);

  const params: GetSequentialGraphParams | undefined = useMemo(() => {
    const p = {
      groupId,
      locationId,
      soilId,
      startDate,
      endDate: endDate || startDate,
    };

    return (
      p.groupId !== undefined
      && p.locationId !== undefined
      && p.startDate !== undefined
      && p.endDate !== undefined
    ) ? p : undefined;
  }, [
    groupId,
    locationId,
    soilId,
    startDate,
    endDate,
  ]);

  return params;
}
